import actionCreatorFactory from 'typescript-fsa';

import { FormName } from '@topconagriculture/feed-types';

import reduxConfig from '../../../store/config';
import { BunkScoreGrade, Params, SettingsManage, ThirdParty } from './settings.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/settings');

export const getSettingsManage = actionCreator.async<{}, Partial<SettingsManage>>('GET_SETTINGS_MANAGE');
export const updateSettingsManage = actionCreator.async<{ data: Params; formName: FormName }, SettingsManage>(
  'UPDATE_SETTINGS_MANAGE',
);
export const getSettingsWithDelay = actionCreator.async<void, SettingsManage>('GET_SETTINGS_WITH_DELAY');
export const updateDLCommunicationStarted = actionCreator.async<{ value: boolean; formName: FormName }, boolean>(
  'UPDATE_DL_COMMUNICATION_STARTED',
);
export const getWeighBridgeSystemsList = actionCreator.async<void, {}>('GET_WEIGHBRIDGE_SYSTEMS_LIST');
export const getThirdParties = actionCreator.async<void, {}>('GET_THIRD_PARTIES');
export const updateThirdParty = actionCreator.async<{}, ThirdParty>('UPDATE_THIRD_PARTY');

export const getBunkScoreGrades = actionCreator.async<void, BunkScoreGrade[]>('GET_BUNK_SCORE_GRADES');
export const resetBunkScoreGrades = actionCreator('RESET_BUNK_SCORE_GRADES');
export const updateBunkScoreGrades = actionCreator.async<Partial<BunkScoreGrade>[], BunkScoreGrade[]>(
  'UPDATE_BUNK_SCORE_GRADES',
);
